/* ============================================
   RIDGE-STYLE THUMBNAIL CAROUSEL
   Hides Slick thumbnails, builds custom strip
   ============================================ */

(function() {
  if (window.innerWidth < 990) return;

  function init() {
    if (document.getElementById('ridge-thumbs')) return;

    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var mediaItems = document.querySelectorAll('.product__media-item');
    if (!mediaItems.length) return;

    // Collect thumbnail sources from Slick slides
    var thumbData = [];
    var slickSlides = document.querySelectorAll('.thumbnail-slider .slick-slide:not(.slick-cloned)');

    if (slickSlides.length) {
      slickSlides.forEach(function(slide, i) {
        var img = slide.querySelector('img');
        if (img && i < mediaItems.length) {
          thumbData.push({ src: img.src, alt: img.alt || '', index: i });
        }
      });
    }

    // Fallback: grab from media items
    if (!thumbData.length) {
      mediaItems.forEach(function(item, i) {
        var img = item.querySelector('img');
        if (img) {
          thumbData.push({ src: img.src, alt: img.alt || '', index: i });
        }
      });
    }

    if (!thumbData.length) return;

    // How many clones to add on each side (enough to fill half the container)
    var CLONES = 3;

    // Build custom strip
    var container = document.createElement('div');
    container.id = 'ridge-thumbs';

    var track = document.createElement('div');
    track.className = 'ridge-thumbs-track';

    // Helper to create a thumb element
    function makeThumb(data, isClone) {
      var thumb = document.createElement('div');
      thumb.className = 'ridge-thumb' + (isClone ? ' is-clone' : '') + (!isClone && data.index === 0 ? ' is-active' : '');
      thumb.dataset.index = data.index;
      if (isClone) thumb.dataset.clone = 'true';

      var img = document.createElement('img');
      img.src = data.src;
      img.alt = data.alt;
      img.loading = 'lazy';

      thumb.appendChild(img);
      return thumb;
    }

    // Add clones of LAST few items at the START
    var startClones = thumbData.slice(-CLONES);
    startClones.forEach(function(data) {
      track.appendChild(makeThumb(data, true));
    });

    // Add all real thumbnails
    thumbData.forEach(function(data) {
      track.appendChild(makeThumb(data, false));
    });

    // Add clones of FIRST few items at the END
    var endClones = thumbData.slice(0, CLONES);
    endClones.forEach(function(data) {
      track.appendChild(makeThumb(data, true));
    });

    container.appendChild(track);

    // Insert into gallery
    var mainSlider = gallery.querySelector('slider-component:not(.thumbnail-slider)');
    if (mainSlider && mainSlider.nextSibling) {
      gallery.insertBefore(container, mainSlider.nextSibling);
    } else {
      gallery.appendChild(container);
    }

    // Center a thumbnail by index (targets real thumbs, not clones)
    function centerThumb(index) {
      // Find the REAL (non-clone) thumb with this index
      var allThumbs = track.querySelectorAll('.ridge-thumb');
      var target = track.querySelector('.ridge-thumb:not(.is-clone)[data-index="' + index + '"]');
      if (!target) return;

      var trackWidth = track.offsetWidth;
      var scrollTo = target.offsetLeft + (target.offsetWidth / 2) - (trackWidth / 2);

      track.scrollTo({ left: Math.max(0, scrollTo), behavior: 'smooth' });

      // Update active on ALL thumbs (real + clones) with same index
      allThumbs.forEach(function(t) { t.classList.remove('is-active'); });
      track.querySelectorAll('.ridge-thumb[data-index="' + index + '"]').forEach(function(t) {
        t.classList.add('is-active');
      });
    }

    // Click: change main image via Slick + center thumb
    track.addEventListener('click', function(e) {
      var thumb = e.target.closest('.ridge-thumb');
      if (!thumb) return;

      var index = parseInt(thumb.dataset.index);

      // Trigger Slick thumbnail click
      if (slickSlides[index]) {
        var btn = slickSlides[index].querySelector('button');
        if (btn) btn.click();
      }

      centerThumb(index);
    });

    // Watch main media items for class changes (arrows etc)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'class' && m.target.classList.contains('is-active')) {
          var idx = Array.prototype.indexOf.call(mediaItems, m.target);
          if (idx >= 0) centerThumb(idx);
        }
      });
    });
    mediaItems.forEach(function(item) {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });

    // Watch Slick current changes too
    var slickObs = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'class' && m.target.classList.contains('slick-current') && !m.target.classList.contains('slick-cloned')) {
          var idx = Array.prototype.indexOf.call(slickSlides, m.target);
          if (idx >= 0) centerThumb(idx);
        }
      });
    });
    slickSlides.forEach(function(slide) {
      slickObs.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    // Center first on init
    setTimeout(function() { centerThumb(0); }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 1500); });
  } else {
    setTimeout(init, 1500);
  }
})();